import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@/config/authConfig';
import { useCallback } from 'react';
import { currentUserService } from '@/services/currentUserService';
import { useCurrentUserStore } from '@/store';

export const useAuth = () => {
  const { instance, inProgress } = useMsal();
  const account = instance.getActiveAccount();

  const login = useCallback(() => {
    instance
      .loginRedirect({
        ...loginRequest,
        redirectStartPage: window.location.origin + '/',
      })
      .catch((e) => {
        console.error('Login failed:', e);
      });
  }, [instance]);

  const loginRedirect = useCallback(() => {
    instance
      .loginRedirect({
        ...loginRequest,
        redirectStartPage: window.location.origin + '/',
      })
      .catch((e) => {
        console.error('Login redirect failed:', e);
      });
  }, [instance]);

  const logout = useCallback(() => {
    useCurrentUserStore.getState().clearUser();
    currentUserService.clearCache();
    instance
      .logoutRedirect({
        postLogoutRedirectUri: '/',
        account: instance.getActiveAccount(),
      })
      .catch((e) => {
        console.error('Logout failed:', e);
      });
  }, [instance]);

  const logoutRedirect = useCallback(() => {
    useCurrentUserStore.getState().clearUser();
    currentUserService.clearCache();
    instance
      .logoutRedirect({
        account: instance.getActiveAccount(),
      })
      .catch((e) => {
        console.error('Logout redirect failed:', e);
      });
  }, [instance]);

  return {
    isAuthenticated: account !== null,
    account,
    inProgress,
    login,
    loginRedirect,
    logout,
    logoutRedirect,
  };
};
